<template>
  <div class="Technology">
    <div class="Technology_con_bg">
      <div class="Technology_center">
        <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>
        <div class="Technology_box" v-if="TechnologyData">
          <div
            class="Technology_box_content"
            v-for="(item, index) in TechnologyData.slice(0, 3)"
            :key="index"
            @click="toArticles(item.id)"
          >
            <div class="Technology_img_box">
              <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
            </div>
            <div class="Technology_text">
              <p class="Technology_text_title">{{ item.title }}</p>
              <div
                class="Technology_text_content"
                v-html="
                  $options.filters.formatTime(item.content, language, 50, 90)
                "
              ></div>
              <div class="open">
                <i class="iconfont icon-jiantou1"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["TechnologyData"],
  // computed: {
  //   Module_title: function () {
  //     return {
  //       name: "Technology",
  //       color: "#fff",
  //       more: true,
  //       ehTitle:this.$t('Nav.Menu.Science'), 
  //       zhTitle: this.$t("Nav.Menu.Science"),
  //     };
  //   },
  // },
  data() {
    return {
      Module_title: { name: "Technology", more: true,color:'#fff',zhTitle:this.$t("Nav.Menu.Science")},
    };
  },
  filters: {
    formatTime: function (value, language, zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      msg = msg.replace(/\s+/g, " "); //去掉npsp
      // return msg.slice(0, zhNum).concat("......");
      if (language == "zh") {
        return msg.slice(0, zhNum).concat("......");
      } else {
        return msg.slice(0, enNum).concat("...");
      }
    },
  },
  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    },
  },
  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue"),
  },
};
</script>

<style lang="scss" scoped>
.Technology {
  background: rgba(6, 108, 172, 1);

  // background: 'url(' + require('../../../assets/image/Index/Society2.jpg') + ')';
  width: 100%;
  height: 654px;
  .Technology_con_bg {
    background: url("../../../assets/image/Index/Technology_bg.png") no-repeat;
    // background-size: cover;
    background-size: 100% 100%;
    .Technology_center {
      overflow: hidden;
      width: 1200px;
      height: 100%;
      margin: 20px auto 0;

      .Technology_title {
        display: inline-block;
        margin: 40px 0 30px;
        color: #fff;
        padding: 10px 30px;
        background: #439f38;
      }
    }

    .Technology_box {
      display: flex;
      flex-direction: row;

      // height: 600px;
      .Technology_box_content:last-child {
        margin-right: 0px;
      }
      .Technology_box_content:first-child {
        margin-left: 0px;
      }
      .Technology_box_content:hover .open {
        transition: 0.2s;
        background: #0070ff !important;
      }
      .Technology_box_content:hover .open i {
        transition: 0.2s;
        color: #fff !important;
      }
      .Technology_box_content {
        cursor: pointer;
        margin: 0 10px;
        // background: #ccc;
        width: 386px;
        height: 453px;

        .Technology_img_box {
          position: relative;
          width: 386px;
          height: 240px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            overflow: hidden;
            object-fit: cover;
          }
        }
        .Technology_text {
          width: 100%;
          height: 213px;
          background: #fff;
          color: #333333;
          border-radius: 0px 0px 0px 30px;
          position: relative;
          .Technology_text_title {
            // height: 90px;
            padding: 20px 20px 0px 20px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            //   height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            // line-height: 33px;
          }
          .Technology_text_content {
            word-wrap: break-word;
            word-break: normal;
            letter-spacing: 0px;
            padding: 10px 20px 0;
            line-height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }

          .open {
            transition: 0.2s;
            cursor: pointer;
            position: absolute;
            bottom: 25px;
            right: 36px;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            // background: #0070ff;
            border: 1px solid #0070ff;
            text-align: right;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            i {
              transition: 0.2s;
              font-size: 14px;
              margin-left: 2px;
              font-weight: 600;
              color: #0070ff;
            }
          }
        }
      }
    }
  }
}
</style>
